import React from "react";
import styled from "styled-components";
import img1 from "../images/missionlogo.avif";
import img2 from "../images/visionlogo.jpg";

import bkgroundimg from "../images/vmv.jpg";
function VisionandMission() {
  return (
    <VisionandMissionCon>
      <div className="bkgpic_msg">
        <div className="message">Mission and Vision Futurebreakgh</div>
      </div>
      <a className="globalhome" href="/">
        Global Home{" "}
      </a>
      | Vision and Mission Futurebreakgh
      <div className="imgandesc">
        <div className="image-container">
          <img className="image" src={img1} alt=" " />
        </div>
        <div className="desc-container">
          <h3>
            Our mission is to simplify logistics for businesses and individuals
            by delivering dependable freight services with transparency, speed,
            and exceptional customer care throughout Ghana and international
            markets.
          </h3>
        </div>

        <div className="desc-container">
          <h3>
            To be the most trusted logistics partner in Ghana, known for
            excellence, reliability, and outstanding customer service.
          </h3>
        </div>
        <div className="image-container">
          <img className="image" src={img2} alt=" " />
        </div>
      </div>
    </VisionandMissionCon>
  );
}

export default VisionandMission;

const VisionandMissionCon = styled.div`
  width: 75vw;
  margin-left: calc((100vw - 75vw) / 2);
  margin-right: calc((100vw - 75vw) / 2);

  .bkgpic_msg {
    background-image: url(${bkgroundimg});
    background-repeat: no-repeat;
    background-position: center; /* Center the background image */
    background-size: cover; /* Ensure the image covers the entire div */
    height: 30vh;
    display: flex; /* Use flexbox to center the text inside */
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    position: relative; /* Allow positioning of text elements over the image */
  }

  .message {
    font-weight: bold;
color: white;
    font-size: 50px;
  }
  .globalhome {
    padding-bottom: 20px;
  }

  .imgandesc {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    justify-content: center;
    margin-top: 50px;
    gap: 30px;
  }
  .image-container .image {
    width: 10vw;
    height: 20vh;
    border-radius: 50%;
    border: 2px solid gainsboro;
    align-items: center;.
       justify-content: center;

  }

  .imgandesc .desc-container {
    padding: 20px;

    text-align: justify;
  }

  @media (max-width: 700px) {
    width: 100vw;

    .imgandesc {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      justify-content: center;
      margin-top: 50px;
      gap: 30px;
      margin-left: -85px;
      padding-left: 5px;
      padding-right: 15px;
    }
    .image-container .image {
      width: 100vw;
      height: 30vh;
      justify-content: center;
      align-items: center;
      border-radius: 0px 200px 200px 0px;
    }
    .desc-containe {
      width: 100%;
    }
    .bkgpic_msg {
      margin-left: -65px;
    }
  }
`;
